import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const headline = css(typography.effra58Modal, {
  fontWeight: fontWeights.medium,
  margin: '0 0 24px',

  [MediaQueries.mdAndUp]: {
    ...typography.effra34,
    fontWeight: fontWeights.medium,
    marginBottom: 32,
  },
});

export const thankyouHeadline = css({
  marginBottom: 8,

  [MediaQueries.mdAndUp]: {
    marginBottom: 16,
  },
});

export const generalError = css(typography.effra14, {
  alignItems: 'center',
  border: `1px solid ${colorsPalette.red120}`,
  color: colorsPalette.red120,
  display: 'flex',
  height: 48,
  marginBottom: 25,
  width: '100%',

  [MediaQueries.lgndUp]: {
    margin: '40px 0',
  },
});

export const errorIcon = css({
  margin: '0 20px',
});

export const privacyLabel = css({
  lineHeight: 1.5,
  paddingRight: 7,
});

export const checkbox = css({
  fontSize: 16,
});

export const containerMargin = css({
  margin: '24px 0 64px',

  [MediaQueries.mdAndUp]: {
    margin: '40px 0 96px',
  },
});

export const contactNumberBlock = css({
  borderTop: `1px solid ${colorsPalette.grey20}`,
  display: 'flex',
  paddingTop: 24,
  marginTop: 42,

  [MediaQueries.mdAndUp]: {
    marginTop: 58,
  },
});

export const contactNumberImageContainer = css({
  borderRadius: '50%',
  flex: '0 0 48px',
  height: 48,
  lineHeight: 0,
  marginRight: 18,
  overflow: 'hidden',
});

export const contactNumberImage = css({
  height: 48,
  width: 48,
});

export const contactNumberTitle = css(typography.effra16, {
  color: colorsPalette.teal,
  fontWeight: fontWeights.medium,
  lineHeight: 1.5,
});

export const contactNumberLink = css(typography.effra16, {
  color: colorsPalette.black,
  lineHeight: 1.5,
  textDecoration: 'none',

  ':focus, :hover': {
    textDecoration: 'underline',
  },
});

export const enquiryInput = css({
  marginBottom: 24,
  width: '100%',
});

export const phoneNumberField = css({
  marginBottom: 33,
});

export const phoneNumberFieldProps = {
  container: {
    minHeight: 56,
    padding: '13px 16px',

    '&[data-shrink="true"]': {
      padding: '13px 16px',
    },
  },

  placeholder: {
    position: 'absolute',
    top: 4,
  },

  dialingCode: {
    fontSize: 16,
  },

  inputValue: {
    fontSize: 16,
  },

  input: {
    fontSize: 16,
  },
};

export const inputProps = {
  customLabelCss: css({
    fontSize: 16,
  }),

  customContainerCss: css({
    height: 56,
    paddingTop: 17,
  }),

  customFieldCss: css({
    fontSize: 16,
  }),
};

export const checkboxWrapper = css({
  marginBottom: 33,
});

export const button = css({
  maxWidth: 210,
  width: '100%',
  wordBreak: 'break-all',

  [MediaQueries.mdAndUp]: {
    maxWidth: 'initial',
    minWidth: 180,
    width: 'auto',
  },

  [MediaQueries.lgAndUp]: {
    minWidth: 'initial',
  },
});

export const submitButton = css({
  display: 'block',
  marginBottom: 32,
  maxWidth: 'none',

  [MediaQueries.mdAndUp]: {
    width: '100%',
  },
});

export const text = css(typography.effra18, {
  marginBottom: 40,
  lineHeight: 1.67,
});
